import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { HelpService } from '../../../services/help.service';
import { ExperienceManager } from '../../../managers/experience.manager';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'lex-log-mfa-selection',
    templateUrl: './login-mfa-selection.component.html',
    styleUrls: ['./login-mfa-selection.component.scss'],
    standalone: false
})
export class LoginMfaSelectionComponent extends BaseComponent implements OnInit, OnDestroy {
	public mfaSelectedMethod: MfaMethod;
	public isLoading: boolean = false;
	public hasError = false;

	constructor(
		public readonly authenticationService: AuthenticationService,
		private readonly router: Router,
		private readonly helpService: HelpService,
		private readonly experienceManager: ExperienceManager,
		private readonly activatedRoute: ActivatedRoute
	) {
		super();

		this.experienceManager.updateState({
			showTopBar: false
		});
	}

	ngOnDestroy() {
		this.experienceManager.updateState({
			showTopBar: true
		});
	}

	ngOnInit() {
		this.helpService.updateHelpLink('logging-in');
	}

	public sendCode(method: MfaMethod) {
		this.mfaSelectedMethod = method;

		this.isLoading = true;
		this.hasError = false;

		this.authenticationService
			.requestMfaCode(this.mfaSelectedMethod)
			.subscribe({
				next: () => {
					this.router.navigate(['../login-challenge'], { relativeTo: this.activatedRoute });
				},
				error: (error) => {
					if (error.status === 400
						|| error.name === 'HttpErrorResponse') {
						this.authenticationService.logout().subscribe(() =>
							this.router.navigate(['/'])
						);
					} else {
						this.hasError = true;
					}

					this.isLoading = false;
				}
			});
	}
}

type MfaMethod = 'Email';
